import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Backdrop, CircularProgress } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "@mui/material/Card";
import moment from "moment";
import "./reportBugAdminPage.css";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {
	adminAllBugReportRequest,
	adminAllBugReportStatusRequest,
} from "../../../redux/reducers/ducks/contactDuck";
import MessagePopup from "../review/messagePopup";

export default function BugReportMainPage() {
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [openDialog, setOpenDialog] = useState({
		isOpen: false,
		msg: null,
	});

	const [isChangeCategoryData, setIsChangeCategoryData] = useState(false);
	const { isAdminStatus, adminReviewLoading, adminAllBugReportData } =
		useSelector((state) => {
			return {
				isAdminStatus: state?.seller?.isAdminChangeStatus,
				adminReviewLoading: state?.adminReview?.adminReviewLoading,
				adminAllBugReportData: state?.contact?.adminAllBugReportData,
			};
		});

	const dispatch = useDispatch();
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const getProperClass = (status) => {
		if (status === "pending") return "contact-pending-color";
		else if (status === "complete") return "contact-approve-color";
		else return "contact-in-review-color";
	};

	const columns = [
		{ id: "name", label: `Email`, minWidth: 130 },
		{ id: "code1", label: "Bug Message", minWidth: 100 },
		{ id: "code2", label: "Date", minWidth: 100 },
		{ id: "code3", label: "Status", minWidth: 100 },
	];

	useEffect(() => {
		const requestData = {
			page: page + 1,
			pageSize: rowsPerPage,
		};
		const timeout = setTimeout(() => {
			dispatch(adminAllBugReportRequest(requestData));
			setIsChangeCategoryData(false);
		}, 1000);

		return () => clearTimeout(timeout);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, rowsPerPage]);

	const handleStatusChange = (event, Id) => {
		const requestData = {
			reportBugId: Id,
			status: event.target.value,
		};
		dispatch(adminAllBugReportStatusRequest(requestData));
		setIsChangeCategoryData(true);
	};

	useEffect(() => {
		if (isAdminStatus) {
			const requestData = {
				page: page + 1,
				pageSize: rowsPerPage,
			};
			dispatch(adminAllBugReportRequest(requestData));
			setIsChangeCategoryData(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAdminStatus, page, dispatch]);

	const handleRowsPerPage = (e) => {
		setRowsPerPage(e.target.value);
	};

	useEffect(() => {
		const requestData = {
			page: page + 1,
			pageSize: rowsPerPage,
		};
		dispatch(adminAllBugReportRequest(requestData));
	}, []);

	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, [page]);

	return (
		<div className="cardParent">
			{(isChangeCategoryData || adminReviewLoading) && (
				<Backdrop
					sx={{ color: "#fff", zIndex: 100 }}
					open={isChangeCategoryData || adminReviewLoading}
				>
					<div className="d-flex  loaderCenter justify-content-center align-item-center">
						<CircularProgress color="inherit" />
					</div>
				</Backdrop>
			)}
			<div>
				<Card className="card-content">
					<div className="parent-cat">{/* <div>Contact Portal</div> */}</div>
					<Paper
						sx={{ width: "100%", overflow: "hidden" }}
						className="bg-white shadow"
					>
						<TableContainer>
							<Table stickyHeader aria-label="sticky table">
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.id}
												align={column.align}
												style={{ minWidth: column.minWidth, fontSize: "22px" }}
											>
												{column.label}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{adminAllBugReportData?.data?.records?.length > 0 ? (
										adminAllBugReportData?.data?.records?.map((cat) => {
											const date = moment?.utc(cat?.createdAt);
											const formattedDate = date.format("MMMM DD, YYYY");
											return (
												<TableRow
													hover
													role="checkbox"
													tabIndex={-1}
													key={cat?.id}
												>
													<TableCell>{cat?.email}</TableCell>
													<TableCell
														onClick={() =>
															setOpenDialog({
																isOpen: true,
																msg: cat?.reportMessage,
															})
														}
														className="report-bug-cursor"
													>
														{cat?.reportMessage?.length > 0
															? cat?.reportMessage?.split(" ")[0] + "..."
															: ""}
													</TableCell>
													<TableCell>{formattedDate}</TableCell>
													<TableCell sx={{ whiteSpace: "noWrap" }}>
														<FormControl sx={{ minWidth: 120 }}>
															<Select
																labelId="demo-simple-select-label"
																id="demo-simple-select"
																value={cat?.status}
																onChange={(e) => {
																	handleStatusChange(e, cat.id);
																}}
																className={`selectStatuses ${getProperClass(
																	cat?.status
																)}`}
																placeholder="Select status"
															>
																<MenuItem value="pending">Pending</MenuItem>
																<MenuItem value="inreview">In Review</MenuItem>
																<MenuItem value="complete">Completed</MenuItem>
															</Select>
														</FormControl>
													</TableCell>
												</TableRow>
											);
										})
									) : (
										<TableRow sx={{ margin: 4, display: "flex" }}>
											<TableCell colSpan={4}> No Bug Report</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						{adminAllBugReportData?.records?.length > 0 && (
							<>
								<TablePagination
									component="div"
									onRowsPerPageChange={handleRowsPerPage}
									rowsPerPage={rowsPerPage}
									count={adminAllBugReportData?.totalRecords}
									page={page}
									onPageChange={handleChangePage}
								/>
								<div className="d-flex justify-content-end ps-5 pe-3 py-3">
									Page: {page + 1}
								</div>
							</>
						)}
					</Paper>
				</Card>
			</div>
			<MessagePopup showPopup={openDialog} setShowPopup={setOpenDialog} />
		</div>
	);
}
